import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

import {CARD_HEIGHT} from '../config';

export const styles = StyleSheet.create({
  base: {
    minHeight: CARD_HEIGHT,
    minWidth: 250,
    justifyContent: 'space-between',
  },
  cardHeaderText: {
    marginBottom: 12,
  },
  listItem: {
    paddingVertical: 0,
    marginTop: 10,
  },
  listItemFirst: {
    marginTop: 0,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginTop: 10,
  },
});
